var _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 40",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "docTitle"
  }, "File Folder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "docTitle"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5,6l-4-6H0v31c0,5,4,9,9,9h30c5,0,9-4,9-9V6H21.5z M46,31c0,3.9-3.1,7-7,7H9c-3.9,0-7-3.1-7-7V2h14.5l4,6H46V31z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m32.7 30-5.2-9.1-2.7 1.3-3.7-5.2-7.4 13h19zm-11.4-9.3 2.8 4.1 2.6-1.2 2.6 4.5h-12.1l4.1-7.4z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 16.5,
    r: 2.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/docs.0871044bdf24473d52693177f5ca951b.svg";
export { ForwardRef as ReactComponent };